// extracted by mini-css-extract-plugin
export default {"melodyVideo":"DL-z","isFullWidth":"EL-z","landingPageVideo":"FL-z","play":"GL-z","iframeVideo":"HL-z","playHidden":"IL-z","fullwidth":"JL-z"};